export default "__VITE_ASSET__DhmAABiW__"